import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Home, Search, ArrowRight, FileText, Smartphone } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found-page">
            <Helmet>
                <title>Page Not Found | Kodebuild</title>
                <meta name="description" content="The page you are looking for doesn't exist. Explore Kodebuild's services in web development, mobile apps, and AI automation." />
            </Helmet>

            <div className="container">
                <motion.div 
                    className="not-found-content"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="error-code">404</div>
                    <h1 className="error-title">Oops! Page <span>Not Found</span></h1>
                    <p className="error-message">
                        The page you're looking for might have been moved, deleted, or perhaps you just typed a wrong address. 
                        Don't worry, we can help you find your way back.
                    </p>

                    <div className="nav-suggestions">
                        <h3>Try one of these instead:</h3>
                        <div className="suggestions-grid">
                            <Link to="/" className="suggestion-card">
                                <Home size={24} />
                                <span>Homepage</span>
                            </Link>
                            <Link to="/work" className="suggestion-card">
                                <FileText size={24} />
                                <span>Our Work</span>
                            </Link>
                            <Link to="/service/software-engineering" className="suggestion-card">
                                <Smartphone size={24} />
                                <span>Services</span>
                            </Link>
                            <Link to="/contact" className="suggestion-card">
                                <Search size={24} />
                                <span>Contact Us</span>
                            </Link>
                        </div>
                    </div>

                    <div className="not-found-actions">
                        <Link to="/" className="btn-primary glow-hover">
                            <Home size={18} /> Back to Safety
                        </Link>
                        <Link to="/contact" className="btn-secondary">
                            Report a Bug <ArrowRight size={18} />
                        </Link>
                    </div>

                    <div className="publisher-content-booster" data-nosnippet>
                        <h3>Engineering Innovation in Every Byte</h3>
                        <p>
                            Kodebuild specializes in custom software engineering, web development, and AI automation. 
                            If you were looking for our portfolio or specialized services like cybersecurity audits and 
                            cloud-native architectures, you can find them in our services section.
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFound;
